import pickBy from 'lodash/pickBy';
import { INormalizedLandingElement } from '~/src/services/projects';

// TODO: погрумить, возможно эти методы можно более эффективно написать
export const prepareBlockColumns = (data: INormalizedLandingElement, blockName: string, customStyles: any) => {
    const tempProps = JSON.parse(JSON.stringify(data));
    const result = {};
    for (const i in tempProps) {
        const keys = i.split('.');
        if (keys[1].indexOf(blockName) === -1) continue;
        keys[0] = keys[0].match(/\w+/g)[0];
        const blockKey = keys[keys.length - 1].match(/\w+/g)[0];
        tempProps[i].customStyles = { [blockKey] : customStyles[keys.join('.').trim()] };
        keys.reduce(function (acc, key, index) {
            return acc[key] || (acc[key] = isNaN(Number(keys[index + 1])) ? (keys.length - 1 == index ? tempProps[i] : {}) : []);
        }, result);
    }
    return result;
};

export const prepareColumnStyles = (columns: INormalizedLandingElement, customStyles: any) => {
    for (const i in columns) {
        const tempStyles = pickBy(
            customStyles,
            (item, key) => {
                return key.indexOf(columns[i].renderId) !== -1;
            },
        );
        const customStyle = {};
        for (const j in tempStyles) {
            if (j === columns[i].renderId) {
                customStyle[columns[i].title.match(/\w+/g)[0]] = tempStyles[j];
            } else {
                customStyle[j.replace(columns[i].renderId + '.', '')] = tempStyles[j];
            }
        }
        columns[i].customStyles = Object.assign(customStyle);
        columns[i].scrollId = columns[i].id.replace(/(\w*)\[(\d*)\]/mg, '$1-$2').replace('.', '-');
    }
    return Object.values(columns);
};
